<template>
  <a
    href="#"
    class="block px-4 py-3 border-b text-black no-underline text-xs2 hover:bg-grey-lightest"
    @click.prevent="$emit('click')"
  >
    <p class="flex justify-between items-center font-semibold">
      <span class="truncate">
        <span class="text-brand">{{ author }}</span>
        <span v-if="when"> | {{ datePrefix }}{{ when }}</span>
      </span>
      <slot name="badge"></slot>
    </p>
    <p class="font-semibold truncate mt-1">
      {{ title }}
      <slot name="title"></slot>
    </p>
    <p class="truncate text-grey-darker" v-if="body">{{ body }}</p>
    <slot></slot>
  </a>
</template>

<script>
import moment from "moment";

/**
 * One row of a vault dashboard panel: author line (name | date), title,
 * one-line body. Slots: `badge` (right of the author line), `title`
 * (inline after the title), default (extra lines under the body).
 */
export default {
  name: "DashboardListItem",

  props: {
    author: { type: String, default: "" },
    date: { type: [String, Date, Object], default: null },
    datePrefix: { type: String, default: "" },
    title: { type: String, default: "" },
    body: { type: String, default: "" },
  },

  computed: {
    // today: "3:15 pm", otherwise "8 Oct 2026"
    when() {
      if (!this.date) {
        return "";
      }
      const date = moment(this.date);
      if (!date.isValid()) {
        return "";
      }
      return date.isSame(moment(), "day")
        ? date.format("h:mm a")
        : date.format("D MMM YYYY");
    },
  },
};
</script>
